export default __webpack_public_path__ + "static/media/Savant's Leggings of Twining Smoke.88125428.jpg";